// Base entry point - jQuery is loaded globally via jquery-global.js
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "./channels"

// Import jQuery UI - it will use the global jQuery from jquery-global.js
import "jquery-ui-dist/jquery-ui.js"
import "tablesorter"

// Start Rails UJS and ActiveStorage
Rails.start()
ActiveStorage.start()
